import type { Components, Theme } from '@mui/material/styles'
import { colorTokens } from '../tokens/colorTokens'

// blocks "-", "+", "e"/"E" on number inputs so negative/scientific-notation values can't be typed
const blockInvalidNumberChars = (event: React.KeyboardEvent<HTMLInputElement>) => {
    const target = event.target as HTMLInputElement
    if (target.type !== 'number') return
    if (['-', '+', 'e', 'E'].includes(event.key)) {
        event.preventDefault()
    }
}

export const textFieldTheme: Components<Theme> = {
    MuiTextField: {
        // so far supporting just outlined dense
        defaultProps: {
            margin: 'dense',
            variant: 'outlined',
            onKeyDown: blockInvalidNumberChars,
        },
    },
    MuiInputLabel: {
        styleOverrides: {
            root: {
                '&.Mui-focused': {
                    color: colorTokens.border.focus,
                },
            },
        },
    },
    MuiOutlinedInput: {
        styleOverrides: {
            root: {
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderColor: colorTokens.border.focus,
                    borderWidth: '1px',
                },
            },
        },
    },
}
